const SECTIONS = {
	autoAlerts: { title: "Auto Alerts", description: "Note for auto alerts", tooltipDisabled: "" },
	bodyShop: {
		title: "Total Body Shop Gross",
		description: "Note for total body shop gross",
		tooltipDisabled: "",
	},
	callActivityPerformance: { title: "Call Activity Performance", description: "Note for call activity performance", tooltipDisabled: "" },
	cashAndLeaseBump: { title: "Cash And Lease Bump", description: "Note for cash and lease bump", tooltipDisabled: "" },
	cit: { title: "Contracts in Transit (CIT) Bonus", description: "Note for Contracts in Transit (CIT) Bonus", tooltipDisabled: "" },
	crossStoreCommissions: { title: "Cross-Store Commissions", description: "Note for cross-store commissions", tooltipDisabled: "" },
	customerSatisfaction: {
		title: "Customer Satisfaction",
		description: "Note for customer satisfaction",
		tooltipDisabled: "You must have some franchise who includes CSI program",
	},
	demoAllowance: { title: "Demo Allowance", description: "Note for demo allowance", tooltipDisabled: "" },
	departmentOverrideNetIncome: {
		title: "Dept. Override Net Inc.",
		description: "Note for department override net income",
		tooltipDisabled: "",
	},
	ebe: {
		title: "EBE (Quarterly Opp.)",
		description: "Note for EBE",
		tooltipDisabled: "You must have some franchise who includes EBE program",
	},
	followUpPerformanceBonus: { title: "Follow Up Performance Bonus", description: "Note for follow-up performance", tooltipDisabled: "" },
	holidayPay: { title: "Holiday Pay", description: "Note for holiday pay", tooltipDisabled: "" },
	growthBonus: { title: "Growth Bonus", description: "Note for growth bonus", tooltipDisabled: "" },
	longevity: { title: "Longevity", type: "list", description: "Note for longevity", tooltipDisabled: "" },
	marketShare: { title: "Market Share", description: "Note for market share", tooltipDisabled: "" },
	maxPayout: { title: "Max Payout", description: "Note for max payout", tooltipDisabled: "" },
	modelBased: { title: "Model-Based Commissions", description: "Note for model-based commissions", tooltipDisabled: "" },
	packs: { title: "Packs", description: "Note for packs", tooltipDisabled: "" },
	parts: { title: "Total Parts Gross", description: "Note for total parts gross", tooltipDisabled: "" },
	pase: {
		title: "PASE (Monthly Opp.)",
		description: "Note for PASE",
		tooltipDisabled: "You must have some franchise who includes PASE program",
	},
	pinnacle: {
		title: "Pinnacle Compliance",
		description: "Note for Pinnacle",
		tooltipDisabled: "Only available when you have Cadillac as part of your franchises",
	},
	productBonuses: { title: "Product Bonuses", type: "emptyList", description: "Note for product bonuses", tooltipDisabled: "" },
	pvrQualifier: { title: "PVR Qualifier Bonus", type: "list", description: "Note for PVR Qualifier bonus", tooltipDisabled: "" },
	operatingCosts: { title: "Operating Costs", description: "Note for Operating Costs", tooltipDisabled: "" },
	rankingBonus: { title: "Ranking Bonus", description: "Note for ranking bonus", tooltipDisabled: "" },
	retentionPay: { title: "Retention Pay", description: "Note for retention pay", tooltipDisabled: "" },
	service: { title: "Total Service Gross", description: "Note for total service gross", tooltipDisabled: "" },
	sfe: {
		title: "SFE (Monthly Opp.)",
		description: "Note for SFE",
		tooltipDisabled: "You must have some franchise who includes SFE program",
	},
	topAdvisorsBonus: { title: "Top Advisor(s) Bonus", type: "list", description: "Note for top advisors bonus", tooltipDisabled: "" },
	topSalesBonus: { title: "Top Performance Bonus", type: "list", description: "Note for top performance bonus", tooltipDisabled: "" },
	topTechniciansBonus: {
		title: "Top Performance Bonus",
		type: "list",
		description: "Note for top performance bonus",
		tooltipDisabled: "",
	},
	volumeBonus: { title: "Volume Bonus", description: "Note for volume bonus", tooltipDisabled: "" },
	variableOperationsGpsBonus: {
		title: "Variable Ops GPS Bonus",
		shortTitle: "Variable Ops GPS Bonus",
		description: "GPS Installation efforts",
		tooltipDisabled: "",
	},
	nightShiftPay: { title: "Night Shift Pay", description: "Note for night shift pay", tooltipDisabled: "" },
	flaggedHoursBonus: { title: "Productivity Bonus", description: "Note for productivity bonus", tooltipDisabled: "" },
	elr: { title: "Effective Labor Rate (ELR) Bonus", description: "Note for effective labor rate (ELR) bonus", tooltipDisabled: "" },
	hro: {
		title: "Hours per Repair Order (Hrs/RO) Bonus",
		description: "Note for hours per repair order (Hrs/RO) bonus",
		tooltipDisabled: "",
	},
	targetedPerformanceBonus: {
		title: "Targeted Performance Bonus",
		description: "GPS Installation efforts",
		tooltipDisabled: "",
	},
};

// Known before as getPayPlanSectionsMap
const getSections = (sections = [], modifiers = []) => {
	return sections.reduce((map, section) => {
		if (Object.hasOwn(SECTIONS, section)) {
			const modifier = modifiers.find((item) => item.section === section);
			map.set(section, { ...SECTIONS[section], ...modifier?.modify });
		}
		return map;
	}, new Map());
};

// Known before as getAvailableSections
const getSectionsAvailable = (allSections = new Map(), model = null, removeSections = []) => {
	const sections = new Map();
	for (const [key, value] of allSections) {
		if (value?.type === "list") {
			if (model?.[key]?.length) {
				sections.set(key, value);
			}
		} else if (model?.[key]) {
			sections.set(key, value);
		}
	}

	for (const key of removeSections) {
		if (!sections.has(key)) {
			sections.set(key, null);
		}
	}

	return sections;
};

// Enable all sections
const getAllSectionsEnabled = (sections = new Map()) => {
	if (sections.size) {
		for (const [, values] of sections) {
			values["disabled"] = false;
		}
	}
	return sections;
};

// Known before as checkSectionsToDisable
const checkSectionsToDisable = (sections = new Map(), sectionsToDisable = []) => {
	if (!sectionsToDisable?.length) {
		return getAllSectionsEnabled(sections);
	}

	if (sections.size) {
		for (const [key, values] of sections) {
			if (sectionsToDisable.includes(key)) {
				values["disabled"] = true;
			}
		}
	}
	return sections;
};

export { checkSectionsToDisable, getSectionsAvailable, getSections, getAllSectionsEnabled };
